<template>
  <div class="wrap">
    <Nav :title="$t('loanRecord')" fixed safeAreaInsetTop placeholder left @leftClick="$router.push('/tabbar/goods')" />
    <div class="content">
      <div class="apply_tips">
        <div class="money">
          <div class="money_title">{{ $t('balance') }}</div>
          <div class="money_num">{{ $money(userInfo.money) }}</div>
        </div>
        <img src="@/assets/new/login/logo.png" alt="">
      </div>
      <div class="btns">
        <div class="btn" v-if="userInfo.auth_check > 0">{{ $t('applying') }}</div>
        <div class="btn" @click="confirm" v-if="userInfo.auth_level == 2">{{ $t('提现') }}</div>
        <div class="btn" @click="toService">{{ $t('contactUs') }}</div>
      </div>
    </div>
    <van-overlay :show="show" @click="overlayChange" z-index="10" class="overlay">
      <div class="overlay_cont" @click.stop>
        <template v-if="flag === 1">
          <div class="cont_item">
            <div class="label">*{{ $t('提现金额') }}</div>
            <div class="value">
              <Field v-model="form.money" type="number" @input="inputChange" :placeholder="$t('请具体说明')" />
            </div>
          </div>
          <div class="cont_btn" @click="endClick1" :style="form.money ? {} : { opacity: .5 }">{{
            $t('user.Button.Two') }}</div>
        </template>
        <template v-else-if="flag === 2">
          <div class="cont_item">
            <div class="label">*{{ $t('提现账号') }}</div>
            <div class="value">
              <Field v-model="form.card" :placeholder="$t('请具体说明')" />
            </div>
          </div>
          <div class="cont_btn" @click="endClick" :style="form.card ? {} : { opacity: .5 }">{{
            $t('user.Button.Two') }}</div>
        </template>
        <template v-else-if="flag === 3">
          <div class="cont_item">
            <div class="label">*{{ $t('提现code') }}</div>
            <div class="value">
              <Field v-model="form.paypass" :placeholder="$t('请具体说明')" />
            </div>
          </div>
          <div class="cont_btn" @click="submit" :style="form.paypass ? {} : { opacity: .5 }">{{
            $t('user.Button.Two') }}</div>
        </template>
        <!-- <div class="cont_btn" @click="submit" :style="form.money && form.paypass && form.card ? {} : { opacity: .5 }">{{
          $t('user.Button.Two') }}</div> -->
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Icon, Overlay, Field, Toast } from "vant";
import { WITHDRAW } from "@/api"
import Nav from "@/components/Navbar";
import { mapGetters } from "vuex"
import RepeatClick from "@/utils/repeat"

const repeatClick = new RepeatClick();
export default {
  components: {
    [Icon.name]: Icon,
    Nav,
    [Overlay.name]: Overlay,
    Field,
    Toast
  },
  data() {
    return {
      show: false,
      flag: 1,
      form: {
        money: '',
        paypass: '',
        card: ''
      }
    }
  },
  created() {

  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    overlayChange() {
      this.show = false;
      this.$nextTick(() => {
        setTimeout(() => {
          this.form = {
            money: '',
            paypass: '',
            card: ''
          }
          this.flag = 1;
        }, 1000)
      })
    },
    confirm() {
      if (this.userInfo.auth_level != 2) return;
      // this.$router.push('/new-withdraw')
      this.show = true
    },
    toService() {
      this.$api.toService();
    },
    inputChange(event) {
      if (Number(event) > Number(this.userInfo.money)) {
        this.form.money = Number(this.userInfo.money)
      }
    },
    endClick1() {
      if (!this.form.money) return;
      let flag = repeatClick.getIsClick();
      if (flag) return;
      repeatClick.setIsClick(true);
      this.show = false;
      this.flag = 2;
      this.show = true;
    },
    endClick() {
      if (!this.form.card) return;
      let flag = repeatClick.getIsClick();
      if (flag) return;
      repeatClick.setIsClick(true);
      this.show = false;
      this.flag = 3;
      this.show = true;
    },
    async submit() {
      if (!this.form.money || !this.form.paypass || !this.form.card) return;
      let flag = repeatClick.getIsClick();
      if (flag) return;
      repeatClick.setIsClick(true);
      try {
        const { ret, msg } = await WITHDRAW({ ...this.form });
        if (ret == 1) {
          Toast(msg)
          this.$store.dispatch('getUserInfo');
          this.overlayChange();
          return
        }
        Toast(msg);
      } catch (error) { }
    }
  },
  created() {
    this.$store.dispatch('getUserInfo')
  },
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: var(--userBg) no-repeat;
  background-size: cover;
  position: relative;

  .content {
    padding: calc(20rem / 16);

    .apply_tips {
      background: var(--btnColor);
      background: url('../../assets/new/index/bg.png') no-repeat;
      background-size: 100% 100%;
      border-radius: calc(20rem / 16);
      color: var(--btnsizeColor);
      // border: 2px solid var(--white);
      padding-left: calc(20rem / 16);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .money {
        font-size: calc(18rem / 16);
        font-weight: bold;
        color: var(--btnsizeColor);

        .money_title {
          margin-bottom: 5px;
        }
      }

      img {
        height: 150px;
        display: block;
      }
    }

    .btns {
      margin-top: calc(180rem / 16);
      position: absolute;
      bottom: 50px;
      width: calc(100% - 40px);

      .btn {
        font-size: calc(20rem / 16);
        height: calc(50rem / 16);
        margin-top: calc(20rem / 16);
        color: var(--btnsizeColor);
        border-radius: calc(10rem /16);
        background: var(--btnColor);
        font-weight: 300;
        text-align: center;
        line-height: calc(50rem / 16);
      }
    }
  }

  .overlay {
    display: flex;
    align-items: center;
    justify-content: center;

    &_cont {
      width: 70vw;
      background: var(--white);
      padding: calc(16rem / 16);
      border-radius: calc(10rem / 16);

      .cont_item {
        padding-bottom: 15px;

        .label {
          font-size: calc(16rem / 16);
          padding-bottom: 5px;
        }

        .value {
          /deep/ .van-cell {
            border: 1px solid #270e31;
            border-radius: 8px;
          }
        }
      }

      .cont_btn {
        background: var(--btnColor);
        color: var(--btnsizeColor);
        border-radius: calc(8rem / 16);
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        text-align: center;
      }
    }
  }
}
</style>